module.exports = __webpack_public_path__ + "img/Time.c9cbe88f.svg";